import { render, staticRenderFns } from "./channelManage.vue?vue&type=template&id=2eb750ad&scoped=true"
import script from "./channelManage.vue?vue&type=script&lang=js"
export * from "./channelManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb750ad",
  null
  
)

export default component.exports